import dataLayer from '@helpers/dataLayer';
import { BaseSyntheticEvent } from 'react';
import { EnquiryForm } from './components/EnquiryTypeForm';

const getSelectContents = (event: BaseSyntheticEvent) => {
  const selectedTexts: Record<string, string> = {};

  Array.from<HTMLSelectElement>(event.target.elements)
    .filter((el) => el.tagName === 'SELECT')
    .forEach((el) => {
      const selectedItem = el.options[el.selectedIndex];
      selectedTexts[el.name] = selectedItem.text;
    });

  return selectedTexts;
};

export const doDataLayerPush = (
  formValues: EnquiryForm & { transactionId: string },
  pageTitle: string,
  event: BaseSyntheticEvent
) => {
  const selectedContents = getSelectContents(event);

  dataLayer.push('generate_lead', {
    form_enquiry: window.pageId,
    form_enquiryname: pageTitle.length ? pageTitle : undefined,
    form_company: formValues.Company || '',
    form_country: selectedContents.Country,
    form_industry: selectedContents.Industry,
    form_product: selectedContents.ProductCategory,
    form_spareparts: formValues.Toggle,
    form_servicetype: formValues.ServiceType?.length ? formValues.ServiceType : undefined,
    form_serial_number: formValues.SerialNr?.length ? formValues.SerialNr.toString() : undefined,
    form_application: selectedContents.Application,
    transaction_id: formValues.transactionId,
  });
};
